import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import AlertModal from 'components/FeedbackModal';
import ConfirmModal from 'components/ConfirmModal';
import apiFetch, { uploadFile } from 'utils/apiFetch';
import { ROUTE_THINK_SEED_CREATION } from 'constants/urls';
import DefaultImage from 'assets/images/think/default.jpg';
import Modal from '@material-ui/core/Modal';
import NoResultsImg from 'assets/images/no_results.svg';
import ArrowBack from 'assets/images/ArrowBack.svg';
import { capitalize } from 'utils/string';
import ChatRoom from 'components/ChatRoom';
import SimpleCarousel from 'components/SimpleCarousel';
import ElementSimpleCard from 'components/Cards/ElementSimpleCard';
import ContentSimpleCard from 'components/Cards/ContentSimpleCard';
import NarrativeSmallCard from 'components/Cards/NarrativeSmallCard';
import CallIcon from 'assets/images/callIcon.svg';
import ThinkSeedContributionForm from 'components/ThinkSeedContributionForm';
import ShareModal from 'components/ShareModal';
import AddUsers from 'components/AddUsers';
import Boost from 'components/Boost';
import Launch from 'components/Launch';
import ThemeTableCard from 'components/Cards/ThemeTableCard';
import Agenda from 'components/Agenda';
import Countdown from 'components/Countdown';
import UserSmallCard from 'components/Cards/UserSmallCard/components';
import paperBin from 'assets/images/think/paperbin.svg';
import Edit from 'assets/images/think/editButton.svg';
import Share from 'assets/images/think/shareButton.svg';
import VDots from 'assets/images/think/verticalDots.svg';
import HDots from 'assets/images/think/horizontalDots.svg';
import ArrowRight from 'assets/images/grey_arrow_right.svg';
import UsersModal from 'components/UsersModal';
import { STATUS_DEAD, TYPE_INDIVIDUAL } from 'constants/tables';
import { DESKTOP_WIDTH } from 'constants/breakPoints';
import { isCommunities } from 'constants/roles';
import { getURLByPhase } from 'utils/calls';
import {
  ThemeTableDetailWrapper, DescriptionTab, DocIframe, OptionsModal, ChatTab, JoinTable,
  JoinModal, LeaveTable, MinimizeCarousel, ButtonAttach, Content, ContentTypes, BoostNextButton, TitleBack, AddButton, CreateTable,
} from './styles';

function ThemeTableDetail(props) {
  const {
    id, actualUser, userElements, literals, showLoading, app, leaveThinkChat, initSection,
    history, callId, narratives, myThinkChatsList, leaveThinkTank, getProposedContent, proposedContent, getChats,
  } = props;

  const call = _.find(narratives, { id: callId });

  // Theme Table data
  const [data, setData] = useState(null);
  const [selectedTab, setSelectedTab] = useState('description');

  const isInTable = () => {
    return actualUser && data && _.find(data.users, { id: actualUser.id });
  };

  const showChatInLateral = () => {
    if (!isInTable()) {
      return false;
    }

    if (window.outerWidth < DESKTOP_WIDTH) {
      return false;
    }

    return true;
  };

  // Errors
  const [errors, setErrors] = useState([]);

  // Chat tab
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapseChat = () => {
    setIsCollapsed(!isCollapsed);
  };

  const removeErrors = () => {
    setErrors([]);
  };

  const createTable = () => {
    history.push(ROUTE_THINK_SEED_CREATION);
  };


  const printErrors = () => {
    if (!errors.length) {
      return null;
    }
    return (
      <AlertModal
        onClose={removeErrors}
        open
        success={false}
        text={errors.join('<br />')}
      />
    );
  };

  const [actualUserRecognizedTo, setActualUserRecognizedTo] = useState(0);
  const [proposedContentList, setProposedContent] = useState([]);

  // Load info
  const loadInfo = () => {
    const endPoint = `theme-table/${id}`;

    showLoading(true);
    apiFetch('GET', { endPoint })
      .then((response) => {
        showLoading(false);
        setData(response);

        const actualUserData = _.find(response.users, { id: actualUser.id });
        const recognizedTo = actualUserData && actualUserData.recognize_to ? actualUserData.recognize_to : 0;
        setActualUserRecognizedTo(recognizedTo);

        if (selectedTab === 'description' && response.type === TYPE_INDIVIDUAL) {
          setSelectedTab('insight');
        }
      })
      .catch((error) => {
        showLoading(false);
        errors.push(error.response.data.error);
        setErrors([...errors]);
      });
  };
  useEffect(() => {
    loadInfo();
    getProposedContent(id);
    setProposedContent(proposedContent);
  }, [id]);

  // Join table
  const [showJoinButton, setShowJoinButton] = useState(true);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showJoinRequestModal, setShowJoinRequestModal] = useState(false);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [inviteUsers, setInviteUsers] = useState(false);
  const [showModalInviteFeedback, setShowModalInviteFeedback] = useState(false);
  const [recognized, setRecognized] = useState(false);

  useEffect(() => {
    if (data) {
      data.users.forEach((user) => {
        if ((user.is_recognized || isCommunities(actualUser.role) || data.creator_id === actualUser.id.toString() || data.creator_id === actualUser.id) && actualUser.id === user.id) {
          setRecognized(true);
        }
      });
    }
  }, [data]);

  const joinTable = () => {
    setShowJoinModal(true);
  };

  const hideLeaveModal = () => {
    setShowLeaveModal(false);
  };

  const leaveTable = () => {
    hideLeaveModal();
    leaveThinkChat(actualUser.id, data.chat_id);
  };

  const leaveModal = () => {
    setShowLeaveModal(true);
  };

  const hideJoinModal = () => {
    setShowJoinModal(false);
  };

  const hideJoinRequestModal = () => {
    setShowJoinRequestModal(false);
  };

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const confirmJoinTable = () => {
    setShowJoinModal(false);
    const endPoint = `theme-table/${id}/join`;

    showLoading(true);
    apiFetch('POST', { endPoint })
      .then(() => {
        showLoading(false);
        setShowJoinButton(false);
        loadInfo();
        getChats();
      })
      .catch((error) => {
        showLoading(false);
        errors.push(error.response.data.error);
        setErrors([...errors]);
      });
  };

  const sendContributionsInThinkSeed = (contributions) => {
    const params = {
      contributions: contributions.contributions.join(','),
      other: contributions.others,
    };
    apiFetch('POST', { endPoint: `think-seed/${id}/contributions` }, params);
    confirmJoinTable();
  };

  const printJoinModal = () => {
    if (!showJoinModal) {
      return null;
    }

    const activeChats = _.filter(myThinkChatsList, (table) => {
      return table.status.id !== STATUS_DEAD && table.type !== TYPE_INDIVIDUAL;
    }).length;

    if (activeChats >= 10) {
      return (
        <AlertModal
          open
          success={false}
          onClose={hideJoinModal}
          text={literals.joinThinkSeedMore10}
        />
      );
    }

    const title = activeChats >= 3 ? literals.joinThinkSeedMore3 : literals.youAreAboutToJoinThinkSeed;

    return (
      <Modal
        open
        onClose={hideJoinModal}
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        style={{ zIndex: 1110000 }}
      >
        <JoinModal style={{ backgroundColor: '#f1f1f1' }}>
          <ThinkSeedContributionForm
            title={title}
            onCancel={hideJoinModal}
            onClick={sendContributionsInThinkSeed}
          />
        </JoinModal>
      </Modal>
    );
  };

  const printJoinRequestModal = () => {
    if (!showJoinRequestModal) {
      return null;
    }
    return (
      <AlertModal
        onClose={hideJoinRequestModal}
        open
        success
        text={literals.joinRequestSuccessfull}
      />
    );
  };

  const printLeaveModal = () => {
    if (!showLeaveModal) {
      return null;
    }
    return (
      <div>
        <ConfirmModal
          onAccept={leaveTable}
          onClose={hideLeaveModal}
          open
          confirmText={literals.confirmLeaveTable}
        />
      </div>
    );
  };

  const [showModalShare, setShowModalShare] = useState(false);

  const handleCloseModalShare = () => {
    setShowModalShare(false);
  };

  const handleOpenModalShare = () => {
    setShowModalShare(true);
  };

  const printShareModal = () => {
    if (data) {
      return (
        <ShareModal
          open={showModalShare}
          docUrl={window.location.href}
          onClose={handleCloseModalShare}
        />
      );
    }
    return <React.Fragment />;
  };

  // Select users
  const [selectedUser, setSelectedUser] = useState(null);

  const removeSelectedUser = () => {
    setSelectedUser(null);
  };

  const handleClickUserBubble = (userId) => {
    const user = _.find(data.users, { id: userId });
    setSelectedUser(user);
  };

  const usersModalMemo = useMemo(() => {
    if (!selectedUser) {
      return null;
    }

    const usersIds = [];
    data.users.forEach((tmpUser) => {
      if (tmpUser.id !== actualUser.id) {
        usersIds.push(tmpUser.id);
      }
    });

    return (
      <UsersModal
        usersIds={usersIds}
        userSelected={selectedUser.id}
        onEnd={removeSelectedUser}
      />
    );
  }, [selectedUser]);

  const printSelectedUser = () => {
    if (!selectedUser) {
      return null;
    }

    return usersModalMemo;
  };

  const [killModal, setKillModal] = useState(false);

  const showKillModal = () => {
    setKillModal(true);
  };

  const hideKillModal = () => {
    setKillModal(false);
  };

  const killSeed = () => {
    const { killThinkSeed, getMyThinkChats } = props;
    hideKillModal();
    if (data.creator_id === actualUser.id.toString() || recognized) {
      killThinkSeed(data.id).then(() => {
        getMyThinkChats();
        history.push('/think');
      });
    }
  };

  const printKillModal = () => {
    if (!killModal) {
      return null;
    }
    return (
      <div>
        <ConfirmModal
          onAccept={killSeed}
          onClose={hideKillModal}
          open
          confirmText={literals.confirmKillTable}
        />
      </div>
    );
  };

  const [launchModal, setLaunchModal] = useState(false);

  const handleClickLaunch = () => {
    setLaunchModal(true);
  };

  const handleCloseLaunch = () => {
    setLaunchModal(false);
  };

  const launchSeed = () => {
    if (launchModal) {
      return <Launch data={data} history={history} user={actualUser} close={handleCloseLaunch} />;
    }
    return null;
  };

  // Boost
  const [boostModal, setBoostModal] = useState(false);

  const handleOpenBoostModal = () => {
    setBoostModal(true);
  };

  const handleCloseBoostModal = () => {
    setBoostModal(false);
  };

  const boostSeed = () => {
    if (boostModal) {
      return <Boost close={handleCloseBoostModal} elementType='think_chat' elementId={data.chat_id} />;
    }
    return null;
  };

  const handleInvite = (selectedUsers) => {
    const usersIds = _.map(selectedUsers, user => user.id);

    apiFetch('POST', { endPoint: `/think-seed/${data.id}/invitations` }, { users: usersIds.join(',') })
      .then(() => {
        setShowModalInviteFeedback(true);
      });
  };

  const closeInvitationsFeedbackModal = () => {
    setShowModalInviteFeedback(false);
  };

  const handleClickCloseInvite = () => {
    setInviteUsers(false);
  };

  const handleClickOpenInvite = () => {
    setInviteUsers(true);
  };

  const printUsersInvitation = () => {
    if (!inviteUsers) {
      return null;
    }
    return (
      <div className='invite_users_tab_content'>
        <AddUsers
          onCancel={handleClickCloseInvite}
          onInvite={handleInvite}
          excludedUsers={data.users.map(user => user.id)}
        />
      </div>
    );
  };

  // Tabs
  useEffect(() => {
    if (initSection) {
      const tab = initSection === 'chat' && (showChatInLateral() || !isInTable()) ? 'description' : initSection;
      setSelectedTab(tab);
    }
  }, [initSection]);

  const selectTab = (event) => {
    const { currentTarget } = event;
    const section = currentTarget.getAttribute('data-section');

    if (section === 'chat') {
      setTimeout(() => {
        const listMessages = document.getElementById('list_messages');
        if (listMessages) {
          const scroll = listMessages.clientHeight;
          if (scroll > 0) {
            document.getElementById('chat_messages').scroll(0, scroll);
          }
        }
      });
    }
    setSelectedTab(section);
  };

  const printTabs = () => {
    if (!isInTable()) {
      return null;
    }

    const tabsName = [];

    if (data.type !== TYPE_INDIVIDUAL) {
      tabsName.push('description');
    }

    tabsName.push('insight');

    if (!showChatInLateral()) {
      tabsName.push('chat');
    }

    const tabs = _.map(tabsName, (tab, index) => (
      <div key={index} className={`tab ${selectedTab === tab ? 'selected' : ''}`} data-section={tab} onClick={selectTab}>{literals[tab]}</div>
    ));

    return (
      <div className='tabs inline'>
        {tabs}
        {isCollapsed && (
          <div className='expand' onClick={handleCollapseChat}>
            <button type='button'>
              <img src={ArrowRight} alt='' />
              <p>{literals.chat}</p>
            </button>
          </div>
        )}
      </div>
    );
  };

  // Count down
  const [remainingTime, setRemainingTime] = useState(null);
  let toCountDown = null;
  const calculateCountdown = () => {
    if (data && typeof data.limit_date !== 'undefined' && moment().unix() <= data.limit_date) {
      const limitDate = moment.unix(data.limit_date);
      const difference = moment.duration(limitDate.diff(moment()));
      setRemainingTime({
        days: difference.get('days'),
        hours: difference.get('hours'),
        minutes: difference.get('minutes'),
        seconds: difference.get('seconds'),
      });
      toCountDown = setTimeout(calculateCountdown, 1000);
    } else {
      setRemainingTime(null);
    }
  };

  useEffect(() => {
    calculateCountdown();

    return (() => {
      if (toCountDown) {
        clearTimeout(toCountDown);
      }
    });
  }, [data]);

  const printCountdown = () => {
    if (!remainingTime) {
      return null;
    }

    return (
      <div className='countdown' style={{ color: '#FFA200', zIndex: '2' }}>
        {remainingTime.days > 0 && `${remainingTime.days} days `}
        {remainingTime.hours > 0 && `${remainingTime.hours} hours `}
        {remainingTime.minutes > 0 && (remainingTime.days === '0' || (remainingTime.days > 0 && remainingTime.hours === '0')) && `${remainingTime.minutes} minutes `}
        {(remainingTime.hours === '0' || (remainingTime.days > 0 && remainingTime.hours === '0' && remainingTime.minutes === '0')) && `${remainingTime.seconds} seconds`}
      </div>
    );
  };

  const [usersIn, setUsersIn] = useState(null);

  useEffect(() => {
    if (data) {
      setUsersIn(data.users);
    }
  }, [data]);

  const handleVoteUp = (event) => {
    const voteTo = parseInt(event.currentTarget.getAttribute('data-user'), 10);
    setActualUserRecognizedTo(voteTo);

    const endPoint = `think-seed/${id}/leader/${voteTo}`;
    apiFetch('POST', { endPoint }).then((res) => {
      const usersAux = usersIn;
      _.forEach(res.data, (user) => {
        _.forEach(usersAux, (aUsers, key) => {
          if (user.id === aUsers.id) {
            usersAux[key].is_recognized = user.recognized;
          }
        });
      });
      setUsersIn(usersAux);
    });

    event.stopPropagation();
  };

  const [userToDelete, setUserToDelete] = useState(0);

  const [deleteUserModal, setDeleteUserModal] = useState(false);

  const deleteC = () => {
    if (userToDelete && recognized) {
      const params = {
        id: data.id,
        user_id: userToDelete,
      };
      apiFetch('POST', { endPoint: `theme-table/${id}/user/${userToDelete}` }, params).then(() => {
        _.remove(data.users, { id: userToDelete });
        setData({ ...data });
      });
      setDeleteUserModal(false);
    }
  };

  const openDeleteUserModal = (userId) => {
    if (!deleteUserModal) {
      setUserToDelete(userId);
    }
    setDeleteUserModal(!deleteUserModal);
  };

  const printDeleteUserModal = () => {
    if (!deleteUserModal) {
      return null;
    }
    return (
      <div>
        <ConfirmModal
          onAccept={deleteC}
          onClose={openDeleteUserModal}
          open
          confirmText={literals.deleteUser}
        />
      </div>
    );
  };

  const goBack = () => {
    history.goBack();
  };

  const handleClickReStart = () => {
    history.push(getURLByPhase(call));
  };

  const handleHallClick = () => {
    history.push(`/calls/${call.id}/hall`);
  };

  const openEditButton = () => {
    history.push(`/think-seed/${id}/edit`);
  };

  const [options, setOptions] = useState(false);

  const handleClickOptions = () => {
    setOptions(!options);
  };

  const deleteTable = () => {
    const { getMyThinkChats } = props;
    const endPoint = `theme-table/${data.id}`;
    showLoading(true);
    apiFetch('DELETE', { endPoint }).then(() => {
      getMyThinkChats();
      history.push('/think');
    });
    showLoading(false);
  };

  const [deleteTableModal, setDeleteTableModal] = useState(false);

  const handleTableModal = () => {
    setDeleteTableModal(!deleteTableModal);
  };

  const printDeleteTableModal = () => {
    if (!deleteTableModal) {
      return null;
    }
    return (
      <div>
        <ConfirmModal
          onAccept={deleteTable}
          onClose={handleTableModal}
          open
          confirmText={literals.deleteTable}
        />
      </div>
    );
  };

  const printOptionsModal = () => {
    if (!options) {
      return null;
    }
    return (
      <OptionsModal>
        <button className='edit' onClick={openEditButton}>Edit</button>
        {data.status.id !== STATUS_DEAD ? (
          <React.Fragment>
            <button className='boost' onClick={handleOpenBoostModal}>Boost</button>
            <button className='launch' onClick={handleClickLaunch}>Launch</button>
            <button className='killButton' onClick={showKillModal}>Kill</button>
            <button className='delete' onClick={handleTableModal}>Delete</button>
          </React.Fragment>
        ) : null}
      </OptionsModal>
    );
  };

  const printDescriptionTab = () => {
    const topics = _.map(data.related_elements, element => (
      <div key={element.id} className={`tag gray ${_.find(userElements, { id: element.id }) ? 'selected' : ''}`}>
        {element.name}
      </div>
    ));

    const mainElement = app.main_element || 'relation_co';
    const mainElementsInfo = [];
    let canManageTable = false;
    let dateEvent = null;
    if (call) {
      const now = Math.floor(new Date().getTime() / 1000);
      dateEvent = call.time_limit;
      let changed = false;
      if (dateEvent < now && data) {
        if (data.enable_thinkchats_meeting && data.think_chats_meeting_date > now && !changed) {
          changed = true;
          dateEvent = data.think_chats_meeting_date;
        }
        if (data.enable_speed_dating && data.speed_dating_date > now && !changed) {
          changed = true;
          dateEvent = data.speed_dating_date;
        }
        if (data.enable_conclusion_meeting && data.conclusiones_meeting_date > now && !changed) {
          changed = true;
          dateEvent = data.conclusiones_meeting_date;
        }
      }
    }

    _.forEach(usersIn, (user) => {
      if (typeof user.elements !== 'undefined' && typeof user.elements[mainElement] !== 'undefined') {
        _.forEach(user.elements[mainElement], (element) => {
          if (!_.find(mainElementsInfo, { id: element.id })) {
            mainElementsInfo.push(element);
          }
        });
      }

      if (user.id === actualUser.id && (user.is_recognized || isCommunities(actualUser.role))) {
        canManageTable = true;
      }
    });

    const content = inviteUsers ? printUsersInvitation() : (
      <React.Fragment>
        <CreateTable>
          <AddButton onClick={createTable}>+</AddButton>
        </CreateTable>
        <div className='grid_info'>
          {data.description ? (
            <div className='description'>{data.description}</div>
          ) : null}
          {topics && topics.length ? (
            <div>{topics}</div>
          ) : null}
        </div>
        <div className='lists'>
          {data && (data.meetings.length || data.speed_datings.length) ? (
            <div className='list'>
              <Agenda meetings={data.meetings} speedDatings={data.speed_datings} />
            </div>
          ) : null}
          {mainElementsInfo && mainElementsInfo.length ? (
            <div className='list'>
              <div className='header_list'>
                <div className='title_section'>
                  <div className='number'>{mainElementsInfo.length}</div>
                  {literals.elements[mainElement] || capitalize(app.main_element)}
                </div>
              </div>
              <SimpleCarousel classesList='element_main_card'>
                {_.map(mainElementsInfo, element => (
                  <ElementSimpleCard key={element.id} data={element} classesList={['element_main_card']} />
                ))}
              </SimpleCarousel>
            </div>
          ) : null }
          {data && data.users && data.users.length ? (
            <div className='list'>
              <div className='header_list'>
                <div className='title_section'>
                  <div className='number'>{data.users.length}</div>
                  {literals.people}
                  {isInTable() ? (
                    <div className='button_header' onClick={handleClickOpenInvite}>
                      <div className='icon_button_header'><i className='fas fa-plus' /></div>
                      <div className='placeholder_button_header'>{literals.invite}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='users'>
                <div style={{ width: '100%' }}>
                  <SimpleCarousel classesList='user_wrapper'>
                    {_.map(data.users, (user) => {
                      let buttonVoteUp = null;
                      if (isInTable() && user.id !== actualUser.id) {
                        if (actualUserRecognizedTo === user.id) {
                          buttonVoteUp = (<button className='voted' onClick={stopPropagation}>{literals.voted}</button>);
                        } else {
                          buttonVoteUp = (
                            <button className='primary btn-sm' onClick={handleVoteUp} data-user={user.id}>{literals.voteup}</button>
                          );
                        }
                      }
                      return (
                        <UserSmallCard key={user.id} onClick={() => handleClickUserBubble(user.id)} user={user} tags={user.contributions} literals={literals} buttonVoteUp={buttonVoteUp} recognized={recognized || data.creator_id === actualUser.id.toString()} actualUser={actualUser} data-user={user.id} onDelete={openDeleteUserModal} />
                      );
                    })}
                  </SimpleCarousel>
                </div>
                <div className='leaveTable'>
                  {isInTable() && <LeaveTable onClick={leaveModal}>{literals.leaveTable}</LeaveTable>}
                </div>
              </div>
            </div>
          ) : null }
        </div>
        {!isInTable() && showJoinButton ? (
          <JoinTable>
            <button className='primary btn_join_sm' style={{ display: 'flex', marginTop: '2rem' }} onClick={joinTable}>{literals.joinThisTable}</button>
          </JoinTable>
        ) : null}
      </React.Fragment>
    );

    return (
      <DescriptionTab image={data.image_big || DefaultImage}>
        {call && (
          <div className='callInfo'>
            <div className='back'>
              <i className='fa fa-arrow-left' onClick={goBack} />
            </div>
            <img src={CallIcon} alt='' />
            <div className='data'>
              <div className='name'>{call.name}</div>
              <div className='live_event'>
                {dateEvent ? (
                  <div className='date'>{`${literals.liveEvent}: ${moment(dateEvent, 'X').format('DD/MM/YYYY')}`}</div>
                ) : null}
              </div>
              {dateEvent && dateEvent > moment().unix() ? (
                <div className='starting'>
                  {literals.startingAt}
                  <Countdown time={dateEvent} enabled />
                </div>
              ) : null}
            </div>
            <div className='buttons'>
              <button className='sec_button' onClick={handleClickReStart}>{literals.reView}</button>
              <button className='main_button' onClick={handleHallClick}>{literals.eventHall}</button>
            </div>
          </div>
        )}
        <div className='header'>
          <div className='curtain' />
          <div className='icon'>
            <div className='table_card'>
              <ThemeTableCard data={data} key={data.id} app={app} user={actualUser} hideInfo />
            </div>
          </div>
          <div className='data'>
            <div className='name'>{data.name}</div>
            {data.status.id !== STATUS_DEAD && remainingTime ? (
              <div className='countdown'>
                {literals.ending}
                {printCountdown()}
              </div>
            ) : null}
            {recognized && data.status.id !== STATUS_DEAD ? (
              <div className='data_buttons'>
                <button className='boost' onClick={handleOpenBoostModal}>{literals.boost}</button>
                <button className='launch' onClick={handleClickLaunch}>{literals.launch}</button>
              </div>
            ) : null}
          </div>
          <div className='buttons'>
            <div className='top_buttons'>
              {recognized && (
                <button className='rounded' onClick={handleTableModal}>
                  <img src={paperBin} alt='' className='paperbin' />
                </button>
              )}
              {data.status.id !== STATUS_DEAD ? (
                <button className='rounded' onClick={handleOpenModalShare}>
                  <img src={Share} alt='' className='share' />
                </button>
              ) : null}
              {recognized && (
                <button className='rounded'>
                  <img src={Edit} alt='' className='edit' onClick={openEditButton} />
                </button>
              )}
              {recognized && !options && (
                <button className='phone_rounded' onClick={handleClickOptions}>
                  <img src={VDots} alt='' className='dots' />
                </button>
              )}
              {recognized && options && (
                <button className='phone_rounded' onClick={handleClickOptions}>
                  <img src={HDots} alt='' className='dots' />
                </button>
              )}
              <button className='phone_rounded' onClick={handleOpenModalShare}>
                <img src={Share} alt='' className='share' />
              </button>
            </div>
            {printOptionsModal()}
            <div className='bottom_buttons'>
              {}

              {recognized && data.status.id !== STATUS_DEAD ? (<button className='kill' onClick={showKillModal}>{literals.kill}</button>) : null}
            </div>
          </div>
        </div>
        {content}
      </DescriptionTab>
    );
  };

  const [addContent, setAddContent] = useState(false);
  const [contentType, setContentType] = useState(null);
  const [form, setForm] = useState(false);

  const setSelectedType = (event) => {
    const { currentTarget } = event;
    const section = currentTarget.getAttribute('data-stage');
    setContentType(section);
  };

  const [name, setName] = useState(null);
  const [desc, setDesc] = useState(null);
  const [url, setUrl] = useState(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (proposedContent !== []) {
      setProposedContent(proposedContent);
    }
  }, [proposedContent]);

  const submitForm = () => {
    if (file !== null && isInTable()) {
      const { proposeContent } = props;
      showLoading(true);
      uploadFile(file, 'file').then((response) => {
        const params = {
          name,
          description: desc,
          type: contentType,
          related_type: data.type,
          related_id: id,
          info: response.info.url,
          info_name: file.name,
          info_type: file.type,
          user_id: actualUser.id,
        };
        proposeContent(params).then(() => {
          getProposedContent(id);
        });
        setAddContent(false);
        setContentType(null);
        setForm(false);
        showLoading(false);
        setName(null);
        setFile(null);
        setDesc(null);
      });
    }
    if (url !== null && isInTable()) {
      const { proposeContent } = props;
      showLoading(true);
      const params = {
        name,
        description: desc,
        type: contentType,
        related_type: data.type,
        related_id: id,
        info: url,
        user_id: actualUser.id,
      };
      proposeContent(params).then(() => {
        getProposedContent(id);
      });
      setAddContent(false);
      setContentType(null);
      setForm(false);
      getProposedContent();
      showLoading(false);
      setName(null);
      setFile(null);
      setDesc(null);
      setUrl(null);
    }
  };

  const handleChangeName = (event) => {
    setName(event.target.value);
  };

  const handleChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const handleChangeFile = (event) => {
    setFile(event.target.files[0]);
  };

  const handleChangeUrl = (event) => {
    setUrl(event.target.value);
  };

  const printForm = () => {
    if (form) {
      if (contentType === 'referral') {
        return (
          <ContentTypes>
            <input type='text' placeholder='Name' value={name} onChange={handleChangeName} />
            <input type='text' placeholder='Description' value={desc} onChange={handleChangeDesc} />
            <input type='text' placeholder='Link' value={url} onChange={handleChangeUrl} />
            <BoostNextButton onClick={submitForm} cont={url != null}>{literals.prop}</BoostNextButton>
          </ContentTypes>
        );
      }
      return (
        <ContentTypes>
          <input type='text' placeholder='Name' value={name} onChange={handleChangeName} />
          <input type='text' placeholder='Description' value={desc} onChange={handleChangeDesc} />
          <label htmlFor='upload-content' className='input'>
            {file ? file.name : literals.attach}
            <i className='fa fa-paperclip' />
          </label>
          <input type='file' placeholder='Content' id='upload-content' style={{ opacity: 0 }} onChange={handleChangeFile} />
          <BoostNextButton onClick={submitForm} cont={file != null}>{literals.prop}</BoostNextButton>
        </ContentTypes>
      );
    }
    return null;
  };

  const setFormShow = () => {
    if (contentType !== null) {
      setForm(true);
    }
  };

  const printSelectProposeContent = () => {
    if (!addContent || form) {
      return null;
    }

    return (
      <ContentTypes>
        <div className='text'>{literals.whatType}</div>
        {}
        <ButtonAttach selected={contentType === 'referral'} margin='1rem' onClick={setSelectedType} data-stage='referral'>
          <i className='fa fa-link' />
          {literals.referral}
        </ButtonAttach>
        <ButtonAttach selected={contentType === 'attach'} margin='1rem' onClick={setSelectedType} data-stage='attach'>
          <i className='fa fa-paperclip' />
          {literals.attach}
        </ButtonAttach>
        <BoostNextButton cont={contentType !== null} onClick={setFormShow}>{literals.next}</BoostNextButton>
      </ContentTypes>
    );
  };

  const setAddContentShow = () => {
    setAddContent(true);
    setForm(false);
  };

  const handleGoBack = () => {
    setAddContent(false);
    setForm(false);
  };

  const openDoc = () => {
    const urlDoc = `https://docs.google.com/document/d/${data.conclusions_document_id}/edit?usp=sharing`;
    window.open(urlDoc);
  };

  const reloadContent = () => {
    getProposedContent(id);
  };

  const [showEntireContent, setShowEntireContent] = useState(false);

  const handleShowEntireContent = () => {
    setShowEntireContent(true);
  };

  const printGoBack = () => {
    return (
      <TitleBack>
        <div className='title_create'>
          <img src={ArrowBack} alt='' onClick={handleGoBack} />
          <div>{literals.addContent}</div>
        </div>
      </TitleBack>
    );
  };

  const printContentTab = () => {
    if (!isInTable() || selectedTab !== 'insight' || !data.conclusions_document_id) {
      return (
        <div className='no_elements'>
          <img alt='' src={NoResultsImg} />
          <div>{literals.noContent}</div>
        </div>
      );
    }
    const urlDoc = `https://docs.google.com/document/d/${data.conclusions_document_id}/edit?usp=sharing&overridemobile=true&fd=true&rm=minimal&headers=false`;
    return (
      <React.Fragment>
        {addContent && printGoBack()}
        <Content>
          {proposedContent && !addContent ? (
            <div className='list'>
              <div className='header_list'>
                <div className='title_section'>
                  <div className='number'>{proposedContent.length}</div>
                  {literals.proposedContent}
                  <div className='button_header' onClick={setAddContentShow}>
                    <div className='icon_button_header'><i className='fas fa-plus' /></div>
                    <div className='placeholder_button_header'>{literals.attachContentToTable}</div>
                  </div>
                </div>
              </div>
              {proposedContent.length ? (
                <MinimizeCarousel className={showEntireContent ? 'show_all' : ''}>
                  <SimpleCarousel classesList='element_main_card'>
                    {_.map(proposedContentList, (element) => {
                      if (typeof element.progress !== 'undefined') {
                        return (
                          <NarrativeSmallCard
                            key={element.id}
                            data={element}
                            color={element.color}
                            classesList='element_main_card'
                          />
                        );
                      }
                      return (<ContentSimpleCard key={element.id} data={element} recognized={recognized} classesList={['element_main_card']} onDelete={reloadContent} />);
                    })}
                  </SimpleCarousel>
                  <div className='opacity_gradient' onClick={handleShowEntireContent}>
                    {literals.viewContent}
                  </div>
                </MinimizeCarousel>
              ) : null}

            </div>) : null}
          {!addContent && (
            <ButtonAttach margin='2rem' onClick={setAddContentShow} color='white' back='#2680EB'>
              <i className='fa fa-plus' />
              {literals.propose}
            </ButtonAttach>
          )}
          {printSelectProposeContent()}
          {printForm()}
          {!addContent ? (
            <React.Fragment>
              <div className='list'>
                <div className='header_list'>
                  <div className='title_section'>
                    {literals.conclusionsAndInsights}
                    <div className='button_header' onClick={openDoc}>
                      <div className='icon_button_header'><i className='fas fa-external-link-alt' /></div>
                      <div className='placeholder_button_header'>{literals.fullEdit}</div>
                    </div>
                  </div>
                </div>
              </div>
              <DocIframe width='90%' height='119rem' scrolling='yes' src={urlDoc} />
            </React.Fragment>
          ) : null}
        </Content>
      </React.Fragment>
    );
  };

  const printChatTab = () => {
    if (!isInTable() || isCollapsed) {
      return null;
    }
    return (<ChatRoom key={data.chat_id} chatId={data.chat_id} tableId={id} theme onCollapse={handleCollapseChat} />);
  };

  const printTabContent = () => {
    return (
      <React.Fragment>
        <div className={selectedTab !== 'description' ? 'hidden' : 'tab_content'}>
          {printDescriptionTab()}
        </div>
        <div className={selectedTab !== 'insight' ? 'hidden' : 'tab_content'}>
          {printContentTab()}
        </div>
        <div className={selectedTab !== 'chat' ? 'hidden' : 'tab_content'}>
          <ChatTab>
            {printChatTab()}
          </ChatTab>
        </div>
      </React.Fragment>
    );
  };

  const printContent = () => {
    if (!data) {
      return null;
    }

    const showChat = showChatInLateral();
    return (
      <React.Fragment>
        <div className={`table_content ${showChat ? 'with_chat' : ''}`} style={{ gridTemplateColumns: isCollapsed ? '100% 0%' : '59% 39%', gap: isCollapsed ? '0' : '2rem' }}>
          <div className='tabs_wrapper'>
            {printTabs()}
            {printTabContent()}
          </div>
          {showChat ? (
            <div className='chat_lateral'>
              {printChatTab()}
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  };

  const printInvitationsFeedbackModal = () => {
    if (!showModalInviteFeedback) {
      return null;
    }

    return (
      <AlertModal
        onClose={closeInvitationsFeedbackModal}
        open
        success
        text={literals.invitationsHasBeenSent}
      />
    );
  };

  return (
    <div>
      {printErrors()}
      {printSelectedUser()}
      {printJoinModal()}
      {printJoinRequestModal()}
      {printLeaveModal()}
      {printShareModal()}
      {printKillModal()}
      {printDeleteUserModal()}
      {printDeleteTableModal()}
      {printInvitationsFeedbackModal()}
      {boostSeed()}
      {launchSeed()}
      <div className='no_horizontal_padding' style={{ paddingBottom: 0 }}>
        <ThemeTableDetailWrapper color={app.color1}>
          {printContent()}
        </ThemeTableDetailWrapper>
      </div>
    </div>
  );
}

ThemeTableDetail.propTypes = {
  id: PropTypes.number.isRequired,
  getChats: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
  showLoading: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  userElements: PropTypes.array,
  callId: PropTypes.number,
  narratives: PropTypes.array,
  myThinkChatsList: PropTypes.array,
  actualUser: PropTypes.object.isRequired,
};

ThemeTableDetail.defaultProps = {
  userElements: [],
  showBackButton: false,
  callId: 0,
  narratives: [],
  myThinkChatsList: [],
};

export default ThemeTableDetail;



// WEBPACK FOOTER //
// ./src/components/ThemeTableDetail/components/index.jsx